import React from 'react';
import ContactUsButton from '../components/ContactUsButton';

const PartyRulesPage: React.FC = () => {
  return (
    <div className="page-container">
      <div className="services-page">
        <div className="services-container">
          <p className="breadcrumb">Services / Parties</p>
          <h1 className="page-title">Parties &amp; Celebrations</h1>
          <p className="page-subtitle">
            Guidelines and information for hosting parties and celebrations at TDS Event Center.
          </p>
          <div className="page-header-actions">
            <ContactUsButton
              buttonText="Click here to ask questions"
              className="contact-button contact-button-alt"
              defaultService="Parties"
              defaultInquiry="information"
            />
          </div>

          <div className="rules-section">
            <h2>Event Types</h2>
            <ul>
              <li>Birthday parties, anniversaries, graduation parties, and other celebrations are welcome.</li>
              <li>All events must be suitable for a community-centered facility.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Decorations &amp; Setup</h2>
            <ul>
              <li>Decorations must be free-standing or attached using non-damaging methods.</li>
              <li>No confetti, glitter, or similar materials that are difficult to clean.</li>
              <li>Balloons must be secured and removed at the end of the event.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Food, Beverages &amp; Music</h2>
            <ul>
              <li>Catered or self-provided food is allowed subject to facility guidelines.</li>
              <li>Alcohol service may be restricted or require additional approvals.</li>
              <li>Music and entertainment must comply with volume limits and quiet hours.</li>
            </ul>
          </div>

          <div className="rules-section">
            <h2>Cleanup &amp; Responsibilities</h2>
            <ul>
              <li>Event organizers are responsible for basic cleanup, including removal of decorations and trash.</li>
              <li>All rental equipment must be removed by the end of the reservation window.</li>
              <li>Additional cleaning fees may apply if extra services are required.</li>
            </ul>
          </div>

        </div>
      </div>
    </div>
  );
};

export default PartyRulesPage;


